const vn = {
  toHome: 'Đang chuyển hướng bạn đến trang chủ...',
  loginSuccess: 'đăng nhập thành công',
  loginFailed: 'Đăng nhập thất bại',
  acntNotExist: 'Tài khoản không tồn tại, vui lòng kiểm tra',
  acntOrPwdError: 'Tài khoản hoặc mật khẩu không chính xác',
  checkFailed: 'Xác minh không hoàn thành',
  selOrg: 'Vui lòng chọn tổ chức bạn muốn tham gia',
  orgTip1: 'Tài khoản đang tham gia vào một tổ chức không tồn tại và không tham gia vào các tổ chức khác. Vui lòng liên hệ với quản trị viên.',
  login: 'Đăng nhập',
  carousel: 'băng chuyền',
  acnt: 'tài khoản',
  enterAcnt: 'Vui lòng nhập',
  pwd: 'mật khẩu',
  enterPwd: 'Vui lòng nhập mật khẩu của bạn',
  remberPwd: 'Nhớ mật khẩu',
  noOrgTip1: 'Tài khoản này không liên quan đến tổ chức, vui lòng liên hệ với quản trị viên',
  pageNotFoundTitle: 'Không tìm thấy trang',
  pageNotFoundTip: 'Rất tiếc, trang bạn đang truy cập không tồn tại.',
  goToBackHome: 'Quay lại trang đầu',
  phoneDisabledTip: 'Số điện thoại đã bị vô hiệu hóa, vui lòng liên hệ với quản trị viên.',
  welcome: 'Chào mừng đến với {{ name }}'
};

export default vn;